<template>
  <v-app class="abeja-app-full-page container">
    <!-- <slot /> -->
    <router-view />
  </v-app>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.abeja-app-full-page {
  overflow: scroll;
  width: 100vw;
  max-width: 100vw;
  height: 100%;
  padding: 0 15px;
}
</style>
